jQuery(document).ready(function ($) {	
	//##############################################//
	//###*****   Slick slider  
	//###*****   Example slider options incl responsive options 
	//##############################################// 

	$('.js-homepage-slider').each(function() {
		$(this).slick({
		  dots: true,
		  arrows: false,
		  centerMode: false,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  fade: true,
		  autoplay: true,
		  autoplaySpeed: 5000,
		  centerPadding: '0px',
		  cssEase: 'ease-in-out',
		  appendDots: '.m-hp-image-slider__dots',
		  
		});
	  })

	$('.js-image-slider').each(function() {
        $(this).slick({
	        dots: true,
	        arrows: true,
	        centerMode: false,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        autoplay: false,
			autoplaySpeed: 0,
			centerPadding: '40px',
			cssEase: 'linear',
			appendArrows: '.c-slider__arrows',
			appendDots: '.c-slider__dots',

		});
	})



	$('.js-slider').each(function() {
        $(this).slick({
	        dots: true,
	        arrows: true,
	        centerMode: false,
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        autoplay: false,
			autoplaySpeed: 0,
			centerPadding: '40px',
			cssEase: 'linear',
			appendArrows: '.c-slider__arrows',
			appendDots: '.c-slider__dots',
			responsive: [
				{
				  breakpoint: 1170,
				  settings: {
				    arrows: true,
				    dots:true,
				    centerMode: false,
				    centerPadding: '40px',
				    slidesToShow: 3
				  }
				},
				{
				  breakpoint: 768,
				  settings: {
				    arrows: false,
				    dots:false,
				    centerMode: true,
				    centerPadding: '40px',
				    slidesToShow: 2
				  }
				},
				{
				  breakpoint: 520,
				  settings: {
				    arrows: false,
				    dots:false,
				    centerMode: true,
				    centerPadding: '70px',
				    slidesToShow: 1
				  }
				},
				{
				  breakpoint: 420,
				  settings: {
				    arrows: false,
				    dots:false,
				    centerMode: true,
				    centerPadding: '20px',
				    slidesToShow: 1
				  }
				}
			]
		});
	})

});